import React from 'react';
import { Field } from 'react-final-form';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Grid, InputAdornment, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import FormTextField from '../../../components/Form/FormTextField/FormTextField';
import { PRIMARY_FONT } from '../../../theme/fontConstants';
import { validateMarginField } from '../helpers/validationHelpers';

const MarginOverrideSection = () => {
  const theme = useTheme();

  const sectionHeaderStyle = {
    color: theme?.palette?.text?.primary,
    fontSize: '20px',
    fontFamily: PRIMARY_FONT[700],
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  };

  const questionStyle = {
    color: theme?.palette?.text?.primary,
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[300],
    marginBottom: theme.spacing(1),
  };

  return (
    <>
      <Typography sx={sectionHeaderStyle}>
        {LanguageConverterV2('contract.create.marginOverride')}
      </Typography>

      <Typography sx={questionStyle}>
        {LanguageConverterV2('contract.create.marginQuestion')}
      </Typography>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6}>
          <Field name="marginRate" validate={validateMarginField}>
            {({ input, meta }) => (
              <FormTextField
                input={input}
                meta={meta}
                label={LanguageConverterV2('contract.create.margin')}
                placeholder={LanguageConverterV2('contract.create.placeholder.rate')}
                required
                fullWidth
                endAdornment={
                  <InputAdornment position="end">
                    <Typography variant="body2" color="text.secondary">
                      %
                    </Typography>
                  </InputAdornment>
                }
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field name="otMarginRate" validate={validateMarginField}>
            {({ input, meta }) => (
              <FormTextField
                input={input}
                meta={meta}
                label={LanguageConverterV2('contract.create.otMargin')}
                placeholder={LanguageConverterV2('contract.create.placeholder.rate')}
                required
                fullWidth
                endAdornment={
                  <InputAdornment position="end">
                    <Typography variant="body2" color="text.secondary">
                      %
                    </Typography>
                  </InputAdornment>
                }
              />
            )}
          </Field>
        </Grid>
      </Grid>
    </>
  );
};

export default MarginOverrideSection;
